import React, { useState } from "react";
import { login } from "../../api/Auth";
import "./login.css";

const Login = () => {
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();

  async function handleLogin() {
    // if return is true, then login was successful
    if (!await login(email, password)){
      alert("Login failed");
    }
  }
  return (
    <>
      <div className="login-wrap">
        <div className="card p-5 border-0 rounded shadow">
          <img
            className="img-fluid bg-scove-dark px-5 py-3 rounded mb-5"
            src="http://scove-systems.com/media-placeholder/scove-cloud-light-bg-transparent-8342x2613-1.png"
            alt=""
          />
          <div className="input-group mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Email"
              aria-label="Email"
              aria-describedby="basic-addon1"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="input-group mb-3">
            <input
              type="password"
              className="form-control"
              placeholder="Password"
              aria-label="Password"
              aria-describedby="basic-addon2"
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button className="btn btn-scove-dark  w-100" onClick={() => handleLogin()}>
            <i className="fa-solid fa-right-to-bracket"></i> Log In
          </button>
          <div className="row mt-4">
            <div className="col-12 mt-3">
              <center>
                <a href="/auth/forgetpassword" className="text-primary">
                Did you forget your password?
                </a>
              </center>
            </div>
          </div>
        </div>
        {/* <div className="card p-4 border-0 rounded shadow mt-1">
          <h6 className="text-dark text-center p-0 m-0">
          Don't have an account? <a href="/register">Register</a>
          </h6>
        </div> */}
      </div>
    </>
  );
};

export default Login;
